<script lang="ts" setup>
import PanelGrid from "@/views/shared/components/PanelGrid.vue";
import PanelCard from "@/views/shared/components/PanelCard.vue";
import ComponentsLibrary from "./components/ComponentsLibrary.vue";
import PageHeader from "@/components/PageHeader.vue";
</script>

<template>
  <main>
  
    <PanelGrid :columns="1">
      <PanelCard>
        <PageHeader
            title="Components Library"
            :breadcrumbs="[
        { label: 'Dashboard', href: '/' },
        { label: 'Components' }
      ]"
        />
        <ComponentsLibrary />
      </PanelCard>
    </PanelGrid>
  </main>
</template>
